module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/banner-app-e3b41ed50fb06e70940902479dc23b6e.png";